import { PlusCircleIcon } from "components/Icons";
// import proxy from "api/proxy";
// import { getStorage } from "store/local";

function onChangeUnitPrice(record, store) {
  console.log("onChangeUnitPrice...", record, store);
  const { unit_price } = store;
  // const unit_price = computeReverseTax(record.product.id, unit_price_w_tax);
  record.sale_price_taxed = unit_price * 1.19;
  store.sale_price_taxed = unit_price * 1.19;
  return true;
}

function getOptionsRooms(record, searchWords) {
  let res = new Map();
  if (record) {
    if (searchWords) {
      res = record.rooms.filter((room) =>
        room.name.toLowerCase().includes(searchWords.toLowerCase()),
      );
    } else {
      res = record.rooms;
    }
  }
  return res;
}

async function layout(config, addRoomMethod) {
  let price_field = { name: "unit_price", width: "10%" };
  if (config.sale_price_taxed_policy) {
    price_field = { name: "sale_price_taxed", width: "10%" };
  }

  const ctxView = {
    model: "hotel.booking.add_rooms.selector",
    form_action: [],
    table_action: [],
    config: config,
    fields: {
      main_guest: {
        type: "many2one",
        model: "party.party",
        readOnly: {
          registration_state: ["check_in", "check_out"],
        },
      },
      unit_price: {
        type: "numeric",
        required: true,
        editable: true,
        // withChange: onChangeUnitPrice,
      },
      discount: {
        type: "numeric",
        // required: true,
      },
      room: {
        type: "many2one",
        model: "hotel.room",
        editable: true,
        options: getOptionsRooms,
      },
      accommodation: {
        type: "many2one",
        model: "product.product",
        recSearch: () => [
          ["template.type", "=", "service"],
          ["template.kind", "=", "accommodation"],
        ],
        attrs: ["template.customer_taxes_used", "code"],
      },
      sale_price_taxed: {
        type: "numeric",
        editable: true,
      },
      availability: {
        type: "integer",
        readOnly: true,
      },
      adults: {
        type: "integer",
        editable: true,
      },
      children: {
        type: "integer",
        editable: true,
      },
      add: {
        type: "button",
        color: "blue",
        iconRight: <PlusCircleIcon className="h-4 w-4 fill-current" />,
        method: addRoomMethod,
      },
    },
    list: [
      { name: "accommodation", width: "20%" },
      { name: "availability", width: "5%" },
      { name: "unit_price", width: "10%" },
      { name: "discount", width: "10%" },
      { name: "adults", width: "5%" },
      { name: "children", width: "5%" },
      { name: "room", width: "20%" },
      { name: "add", width: "15%" },
    ],
    form: [],
  };

  return ctxView;
}

export { layout };
